import { createContext } from 'react';

import { IAuth } from '../types/auth';

export const AuthContext = createContext<IAuth | undefined>(undefined);

export const AuthProvider = AuthContext.Provider;
